<template>
  <v-container fluid class="py-0 px-2">
    <v-text-field
      v-model="search"
      background-color="colorSearchSettings"
      clearable
      :append-icon="mdiMagnify"
      :label="$t('label.search')"
      hide-details
    ></v-text-field>
    <div style="min-height: 1px"></div>
    <v-data-table
      :headers="headers"
      :items="tableData"
      item-key="id"
      :height="$store.state.windowSize.y - 150"
      :search="search"
      fixed-header
      must-sort
      disable-pagination
      hide-default-footer
      class="tableCursor"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td>{{ item.name }}</td>
          <td>{{ item.fullName }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.phone }}</td>
          <td
            v-if="$store.state.auth.userSettings.accUsers.update && item.name != $store.state.auth.user"
            class="px-2 tableSelectCursor"
            @click="((modalEdit = true), (user = { ...item }))"
          >
            <v-icon>{{ mdiPen }}</v-icon>
          </td>
          <td v-else></td>
        </tr>
      </template>
    </v-data-table>
    <v-row>
      <v-col cols="3">
        <v-btn v-if="$store.state.auth.userSettings.accUsers.write" block color="colorNew" @click="dataNew(false)">
          {{ $t('label.addNew') }}
        </v-btn>
      </v-col>
      <v-col cols="3">
        <v-btn v-if="$store.state.auth.userSettings.accUsers.write" block color="colorEdit" @click="dataNew(true)">
          {{ $t('label.addNewAPIuser') }}
        </v-btn>
      </v-col>
    </v-row>
    <!----------DIALOGS------------------------------>
    <v-dialog v-model="modalEdit" persistent width="90%">
      <v-card>
        <v-card-title class="headline colorHeadlineStandard" primary-title>
          {{ $tc('label.user') }} <span v-if="user.token != ''"><h4>-API</h4></span>
          <v-spacer />
          <v-icon large @click="modalEdit = false">{{ mdiClose }}</v-icon>
        </v-card-title>
        <v-card-text class="pa-3">
          <v-form v-model="validForm" ref="userForm">
            <v-row>
              <v-col cols="4">
                <v-menu
                  v-if="user.token != ''"
                  v-model="menuTokenExpire"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      ref="dateText"
                      v-model="formatedTokenExpire"
                      :label="`${$t('label.expire')}`"
                      :append-icon="mdiCalendar"
                      @blur="user.tokenExpire = momentParse(formatedTokenExpire)"
                      :rules="[ruleValidDate]"
                      hide-details
                      dense
                      v-on="on"
                      autocomplete="off"
                    />
                  </template>
                  <v-date-picker
                    :first-day-of-week="$store.state.auth.df.firstDayOfWeek"
                    v-model="user.tokenExpire"
                    no-title
                    @input="menuTokenExpire = false"
                  />
                </v-menu>
                <v-text-field
                  :label="$t('label.loginName')"
                  v-model="user.name"
                  :rules="[ruleRequired]"
                  :disabled="user.id != 0 && user.token == ''"
                  maxlength="128"
                  hide-details
                  autofocus
                  :readonly="user.token != ''"
                  :append-icon="user.token != '' ? mdiClipboardArrowRight : ''"
                  @click:append="copyToClipboard(user.name)"
                />
                <h4 v-if="user.token != '' && user.token != '********'" class="red--text">
                  {{ $t('tt.tokenVisibleOnlyOnce') }}
                </h4>
                <v-textarea
                  v-if="user.token != ''"
                  :label="$t('label.token')"
                  v-model="user.token"
                  :rules="[ruleRequired]"
                  hide-details
                  readonly
                  rows="2"
                  no-resize
                  :append-icon="user.token != '' && user.token != '********' ? mdiClipboardArrowRight : ''"
                  @click:append="copyToClipboard(user.token)"
                />
                <v-btn v-if="user.token != ''" color="colorEdit" small class="mt-3" block @click="modalGenerateToken = true">
                  {{ $t('btn.generate') }}
                </v-btn>
                <v-text-field
                  v-if="user.token == ''"
                  type="password"
                  :label="$t('label.password')"
                  v-model="user.password"
                  :rules="user.id == 0 ? [ruleRequired] : []"
                  hide-details
                  autocomplete="new-password"
                />
                <v-text-field :label="$t('label.name')" v-model="user.fullName" maxlength="256" hide-details />
                <v-select
                  v-model="user.language"
                  :items="listLanguages"
                  item-text="text"
                  item-value="value"
                  :label="$t('label.language')"
                  hide-details
                />
                <v-select
                  v-model="user.formatDate"
                  :items="listDateFormats"
                  item-text="text"
                  item-value="value"
                  :label="$t('label.formatDate')"
                  hide-details
                />
                <v-select
                  v-model="user.formatTime"
                  :items="listTimeFormats"
                  item-text="text"
                  item-value="value"
                  :label="$t('label.formatTime')"
                  hide-details
                />
                <v-select
                  v-model="user.firstDay"
                  :items="listFirstDayOfWeek"
                  item-text="text"
                  item-value="value"
                  :label="$t('label.firstDayOfWeek')"
                  hide-details
                />
                <v-text-field
                  v-if="user.token == ''"
                  :label="$t('label.phone')"
                  v-model="user.phone"
                  maxlength="32"
                  hide-details
                  :prepend-inner-icon="mdiPhone"
                />
                <v-text-field
                  v-if="user.token == ''"
                  :label="$t('label.email')"
                  v-model="user.email"
                  maxlength="128"
                  hide-details
                  :prepend-inner-icon="mdiEmail"
                />
                <v-textarea :label="$t('label.note')" v-model="user.note" no-resize maxlength="512" hide-details rows="4" />
              </v-col>
              <v-col col="8">
                <v-row>
                  <v-col cols="3">
                    <b>{{ $t('label.rightsSettings') }}</b>
                  </v-col>
                  <v-col cols="1">{{ $t('label.read') }}</v-col>
                  <v-col cols="1">{{ $t('label.create') }}</v-col>
                  <v-col cols="1">{{ $t('label.update') }}</v-col>
                  <v-col cols="1">{{ $t('label.delete') }}</v-col>
                  <v-col cols="1">{{ $t('label.import') }}</v-col>
                  <v-col cols="1">{{ $t('label.export') }}</v-col>
                </v-row>
                <v-sheet style="overflow-y: auto; overflow-x: hidden" class="thin-scrollbar pl-4" :height="$store.state.windowSize.y - 280">
                  <v-row>
                    <v-col>
                      <h3>{{ $tc('label.company') }}</h3>
                    </v-col>
                  </v-row>
                  <v-divider />
                  <v-row no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.employee', 1) }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accEmployeesRead" v-bind:disabled="user.accEmployees > 1" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accEmployeesWrite" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accEmployeesUpdate" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accEmployeesDelete" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" class="ml-3" v-model="accEmployeesImport" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" class="ml-3" v-model="accEmployeesExport" />
                    </v-col>
                  </v-row>
                  <v-row v-if="$store.state.auth.settings.planVisits" no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.employee', 1) }}-{{ $t('label.planning') }}</div>
                    </v-col>
                    <v-col cols="2" />
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" hide-details v-model="accEmployeesPlanningUpdate" />
                    </v-col>
                  </v-row>

                  <v-row v-if="$store.state.auth.settings.planVisits" no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.planningGroup', 2) }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accEmployeeGroupsRead" v-bind:disabled="user.accEmployeeGroups > 1" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accEmployeeGroupsWrite" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accEmployeeGroupsUpdate" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accEmployeeGroupsDelete" />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.area', 2) }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox
                        color="colorCheck"
                        v-model="accAreasRead"
                        v-bind:disabled="
                          user.accAreas > 1 ||
                          user.accEmployees > 0 ||
                          user.accUsers > 0 ||
                          user.accCards > 0 ||
                          user.accWorkplaces > 0 ||
                          user.accMobileDevices > 0
                        "
                      />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accAreasWrite" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accAreasUpdate" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accAreasDelete" />
                    </v-col>
                  </v-row>
                  <v-divider />
                  <v-row class="py-0">
                    <v-col class="pb-0">
                      <v-select
                        v-model="user.areas"
                        :label="$t('label.assignedAreas')"
                        :items="listAreas"
                        item-text="name"
                        item-value="id"
                        :return-object="false"
                        multiple
                        chips
                        deletable-chips
                        :menu-props="{ minWidth: '500' }"
                        append-icon="$dropdown"
                        hide-details
                      />
                    </v-col>
                  </v-row>
                  <v-row class="my-0">
                    <v-col cols="5" class="py-0 my-0">
                      <v-checkbox v-model="user.filterAreas" :label="$t('label.useForFilters')" hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="7" class="py-0 my-0">
                      <v-checkbox hide-details v-model="user.archiveGetAll" :label="$t('label.showAllInArchive')" />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col>
                      <h3>{{ $tc('label.visitor', 2) }}</h3>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.visitor', 2) }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accVisitorsRead" v-bind:disabled="user.accVisitors > 1" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accVisitorsWrite" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accVisitorsUpdate" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accVisitorsDelete" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" class="ml-3" v-model="accVisitorsImport" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" class="ml-3" v-model="accVisitorsExport" />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.company', 2) }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox
                        color="colorCheck"
                        v-model="accCompaniesRead"
                        v-bind:disabled="user.accCompanies > 1 || user.accVisitors > 0"
                      />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accCompaniesWrite" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accCompaniesUpdate" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accCompaniesDelete" />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.car', 2) }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox
                        color="colorCheck"
                        v-model="accCarsRead"
                        v-bind:disabled="user.accCars > 1 || user.accVisitors > 0"
                      />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accCarsWrite" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accCarsUpdate" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accCarsDelete" />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="pt-0">
                      <h3>{{ $t('label.configuration') }}</h3>
                      <v-divider />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.user', 2) }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accUsersRead" v-bind:disabled="user.accUsers > 1" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accUsersWrite" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accUsersUpdate" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accUsersDelete" />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.notification', 2) }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accMessagesRead" v-bind:disabled="user.accMessages > 1" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accMessagesWrite" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accMessagesUpdate" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accMessagesDelete" />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.visitorcard', 2) }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accCardsRead" v-bind:disabled="user.accCards > 1" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accCardsWrite" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accCardsUpdate" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accCardsDelete" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" class="ml-3" v-model="accCardsImport" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" class="ml-3" v-model="accCardsExport" />
                    </v-col>
                  </v-row>

                  <v-row class="my-1" no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.itemForInspection', 2) }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox
                        color="colorCheck"
                        v-model="accItemsRead"
                        v-bind:disabled="user.accItems > 1 || user.accAreas > 0"
                      />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accItemsWrite" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accItemsUpdate" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accItemsDelete" />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.documentType', 2) }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accDocumentTypesRead" v-bind:disabled="user.accDocumentTypes > 1" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accDocumentTypesWrite" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accDocumentTypesUpdate" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accDocumentTypesDelete" />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.workplace', 2) }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accWorkplacesRead" v-bind:disabled="user.accWorkplaces > 1" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accWorkplacesWrite" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accWorkplacesUpdate" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accWorkplacesDelete" />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.mobileDevice', 2) }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accMobileDevicesRead" v-bind:disabled="user.accMobileDevices > 1" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accMobileDevicesWrite" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accMobileDevicesUpdate" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accMobileDevicesDelete" />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.terminal', 1) }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accSignTermRead" v-bind:disabled="user.accSignTerm > 1" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accSignTermWrite" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accSignTermUpdate" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accSignTermDelete" />
                    </v-col>
                  </v-row>

                  <v-row class="my-1" no-gutters>
                    <v-col cols="3">
                      <div>{{ $t('label.system') }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accSettingsRead" v-bind:disabled="user.accSettings > 1" />
                    </v-col>
                    <v-col cols="1" />
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accSettingsUpdate" />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3">
                      <div>{{ $tc('label.printTemplate', 2) }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accTemplatesRead" v-bind:disabled="user.accTemplates > 1" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accTemplatesWrite" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accTemplatesUpdate" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accTemplatesDelete" />
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3">
                      <div>{{ $t('label.archive') }}</div>
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" v-model="accArchiveRead" v-bind:disabled="user.accArchive > 1" />
                    </v-col>
                    <v-col cols="1" />
                    <v-col cols="1" />
                    <v-col cols="1" />
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" class="ml-3" v-model="accArchiveImport" />
                    </v-col>
                    <v-col cols="1">
                      <v-simple-checkbox color="colorCheck" class="ml-3" v-model="accArchiveExport" />
                    </v-col>
                  </v-row>
                </v-sheet>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn v-if="user.id && $store.state.auth.userSettings.accUsers.delete" color="colorDelete" @click="modalDelete = true">
            {{ $t('btn.delete') }}
          </v-btn>
          <v-spacer />
          <v-select
            :label="$t('label.preset')"
            :items="listPresets"
            item-text="text"
            item-value="value"
            hide-details
            v-on:change="fillPresets"
          />
          <v-spacer />
          <v-btn color="colorSave" @click="dataSave">
            {{ $t('btn.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogConfirmDelete
      :header="$t('label.delete')"
      :body="`${$t('msg.confirmDelete')}: ${user.name}?`"
      :openDialog.sync="modalDelete"
      v-on:confirm="dataDelete"
    />

    <DialogConfirm
      :header="$t('label.generateToken')"
      :body="`${$t('msg.generateToken')}`"
      :openDialog.sync="modalGenerateToken"
      v-on:confirm="generateToken"
    />
  </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import axios from 'axios';
import DialogConfirmDelete from '@/components/DialogConfirmDelete.vue';
import DialogConfirm from '@/components/DialogConfirm.vue';

import {
  mdiMagnify,
  mdiPen,
  mdiClose,
  mdiFormTextbox,
  mdiFormTextboxPassword,
  mdiPhone,
  mdiEmail,
  mdiCalendar,
  mdiClipboardArrowRight,
} from '@mdi/js';

export default Vue.extend({
  name: 'SettingsUsers',
  components: { DialogConfirmDelete, DialogConfirm },
  data: () => ({
    modalEdit: false,
    modalDelete: false,
    modalImport: false,
    modalGenerateToken: false,
    menuTokenExpire: false,
    listAreas: [],
    validForm: false,
    tableData: [],
    search: '',
    formatedTokenExpire: '',
    user: {
      id: 0,
      name: '',
      password: '',
      fullName: '',
      email: '',
      phone: '',
      note: '',
      accEmployees: 0,
      accEmployeeGroups: 0,
      accMessages: 0,
      accTemplates: 0,
      accCards: 0,
      accCars: 0,
      accWorkplaces: 0,
      accAreas: 0,
      accVisitors: 0,
      accCompanies: 0,
      accUsers: 0,
      accSettings: 0,
      accDocumentTypes: 0,
      accItems: 0,
      accMobileDevices: 0,
      accSignTerm: 0,
      accArchive: 0,
      archiveGetAll: false,
      areas: [],
      filterAreas: false,
      formatDate: '',
      formatTime: '',
      firstDay: 0,
      language: 'en',
      token: '',
      tokenExpire: '',
    },
    listLanguages: [],
    listDateFormats: [
      { text: '21.12.2021', value: 'DD.MM.YYYY' },
      { text: '21/12/2021', value: 'DD/MM/YYYY' },
      { text: '21-12-2021', value: 'DD-MM-YYYY' },
      { text: '2021-12-21', value: 'YYYY-MM-DD' },
      { text: '2021/12/21', value: 'YYYY/MM/DD' },
    ],
    listTimeFormats: [
      { text: '16:23', value: 'HH:mm' },
      { text: '04:23pm', value: 'hh:mmA' },
    ],
    mdiMagnify: mdiMagnify,
    mdiPen: mdiPen,
    mdiClose: mdiClose,
    mdiFormTextbox: mdiFormTextbox,
    mdiFormTextboxPassword: mdiFormTextboxPassword,
    mdiPhone: mdiPhone,
    mdiEmail: mdiEmail,
    mdiCalendar: mdiCalendar,
    mdiClipboardArrowRight: mdiClipboardArrowRight,
  }),
  watch: {
    accEmployeesRead() {
      this.accEmployeesRead && this.user.accEmployeeGroups === 0 ? (this.user.accEmployeeGroups = 1) : '';
      this.accEmployeesRead && this.user.accAreas === 0 ? (this.user.accAreas = 1) : '';
    },
    accEmployeeGroupsRead() {
      this.accEmployeeGroupsRead && this.user.accEmployees === 0 ? (this.user.accEmployees = 1) : '';
    },
    accMessagesRead() {
      this.accMessagesRead && this.user.accEmployeeGroups === 0 ? (this.user.accEmployeeGroups = 1) : '';
    },
    accAreasRead() {
      this.accAreasRead && this.user.accItems === 0 ? (this.user.accItems = 1) : '';
    },
    accVisitorsRead() {
      this.accVisitorsRead && this.user.accCars === 0 ? (this.user.accCars = 1) : '';
      this.accVisitorsRead && this.user.accCompanies === 0 ? (this.user.accCompanies = 1) : '';
    },
    accUsersRead() {
      this.accUsersRead && this.user.accAreas === 0 ? (this.user.accAreas = 1) : '';
    },
    accCardsRead() {
      this.accCardsRead && this.user.accAreas === 0 ? (this.user.accAreas = 1) : '';
    },
    accWorkplacesRead() {
      this.accWorkplacesRead && this.user.accAreas === 0 ? (this.user.accAreas = 1) : '';
    },
    accMobileDevicesRead() {
      this.accMobileDevicesRead && this.user.accAreas === 0 ? (this.user.accAreas = 1) : '';
    },
    'user.tokenExpire'() {
      this.$nextTick(() => {
        var date: string = this.$moment(this.user.tokenExpire).format(this.$store.state.auth.df.date);
        if (date !== 'Invalid date') {
          this.formatedTokenExpire = date;
        } else {
          this.user.tokenExpire = '';
          this.formatedTokenExpire = '';
        }
      });
    },
  },
  mounted() {
    this.listAreasLoad();
    this.listLanguagesLoad();
    this.$nextTick(function () {
      this.dataLoad();
    });
  },
  computed: {
    ruleRequired() {
      return (v: any) => !!v || this.$i18n.t('msg.fieldIsMandatory');
    },
    ruleValidDate() {
      return (v: any) =>
        v == null || v == '' || this.$moment(v, this.$store.state.auth.df.date, true).isValid() || this.$i18n.t('msg.invalidDateFormat');
    },
    listPresets() {
      return [
        { text: this.$i18n.t('label.empty'), value: 'empty' },
        { text: this.$i18n.t('label.porter'), value: 'porter' },
        { text: this.$i18n.tc('label.user'), value: 'user' },
        { text: this.$i18n.t('label.admin'), value: 'admin' },
      ];
    },
    listFirstDayOfWeek: function () {
      return [
        { text: this.$i18n.t('label.sunday'), value: 0 },
        { text: this.$i18n.t('label.monday'), value: 1 },
      ];
    },
    headers: function () {
      return [
        { text: this.$i18n.t('label.loginName'), value: 'name' },
        { text: this.$i18n.t('label.name'), value: 'fullName' },
        { text: this.$i18n.t('label.email'), value: 'email' },
        { text: this.$i18n.t('label.phone'), value: 'phone' },
        { sortable: false, width: '48px' },
      ];
    },
    accEmployeesRead: {
      get() {
        return (this.user.accEmployees & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accEmployees |= 1;
        } else {
          this.user.accEmployees &= ~1;
        }
      },
    },
    accEmployeesWrite: {
      get() {
        return (this.user.accEmployees & 2) === 2;
      },
      set(x) {
        if (x) {
          this.user.accEmployees |= 3;
        } else {
          this.user.accEmployees &= ~2;
        }
      },
    },
    accEmployeesUpdate: {
      get() {
        return (this.user.accEmployees & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accEmployees |= 5;
        } else {
          this.user.accEmployees &= ~4;
        }
      },
    },
    accEmployeesDelete: {
      get() {
        return (this.user.accEmployees & 8) === 8;
      },
      set(x) {
        if (x) {
          this.user.accEmployees |= 9;
        } else {
          this.user.accEmployees &= ~8;
        }
      },
    },
    accEmployeesImport: {
      get() {
        return (this.user.accEmployees & 16) === 16;
      },
      set(x) {
        if (x) {
          this.user.accEmployees |= 17;
        } else {
          this.user.accEmployees &= ~16;
        }
      },
    },
    accEmployeesExport: {
      get() {
        return (this.user.accEmployees & 32) === 32;
      },
      set(x) {
        if (x) {
          this.user.accEmployees |= 33;
        } else {
          this.user.accEmployees &= ~32;
        }
      },
    },
    accEmployeesPlanningUpdate: {
      get() {
        return (this.user.accEmployees & 16384) === 16384;
      },
      set(x) {
        if (x) {
          this.user.accEmployees |= 16389;
        } else {
          this.user.accEmployees &= ~16384;
        }
      },
    },
    accEmployeeGroupsRead: {
      get() {
        return (this.user.accEmployeeGroups & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accEmployeeGroups |= 1;
        } else {
          this.user.accEmployeeGroups &= ~1;
        }
      },
    },
    accEmployeeGroupsWrite: {
      get() {
        return (this.user.accEmployeeGroups & 2) === 2;
      },
      set(x) {
        if (x) {
          this.user.accEmployeeGroups |= 3;
        } else {
          this.user.accEmployeeGroups &= ~2;
        }
      },
    },
    accEmployeeGroupsUpdate: {
      get() {
        return (this.user.accEmployeeGroups & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accEmployeeGroups |= 5;
        } else {
          this.user.accEmployeeGroups &= ~4;
        }
      },
    },
    accEmployeeGroupsDelete: {
      get() {
        return (this.user.accEmployeeGroups & 8) === 8;
      },
      set(x) {
        if (x) {
          this.user.accEmployeeGroups |= 9;
        } else {
          this.user.accEmployeeGroups &= ~8;
        }
      },
    },
    accMessagesRead: {
      get() {
        return (this.user.accMessages & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accMessages |= 1;
        } else {
          this.user.accMessages &= ~1;
        }
      },
    },
    accMessagesWrite: {
      get() {
        return (this.user.accMessages & 2) === 2;
      },
      set(x) {
        if (x) {
          this.user.accMessages |= 3;
        } else {
          this.user.accMessages &= ~2;
        }
      },
    },
    accMessagesUpdate: {
      get() {
        return (this.user.accMessages & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accMessages |= 5;
        } else {
          this.user.accMessages &= ~4;
        }
      },
    },
    accMessagesDelete: {
      get() {
        return (this.user.accMessages & 8) === 8;
      },
      set(x) {
        if (x) {
          this.user.accMessages |= 9;
        } else {
          this.user.accMessages &= ~8;
        }
      },
    },
    accTemplatesRead: {
      get() {
        return (this.user.accTemplates & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accTemplates |= 1;
        } else {
          this.user.accTemplates &= ~1;
        }
      },
    },
    accTemplatesWrite: {
      get() {
        return (this.user.accTemplates & 2) === 2;
      },
      set(x) {
        if (x) {
          this.user.accTemplates |= 3;
        } else {
          this.user.accTemplates &= ~2;
        }
      },
    },
    accTemplatesUpdate: {
      get() {
        return (this.user.accTemplates & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accTemplates |= 5;
        } else {
          this.user.accTemplates &= ~4;
        }
      },
    },
    accTemplatesDelete: {
      get() {
        return (this.user.accTemplates & 8) === 8;
      },
      set(x) {
        if (x) {
          this.user.accTemplates |= 9;
        } else {
          this.user.accTemplates &= ~8;
        }
      },
    },
    accCardsRead: {
      get() {
        return (this.user.accCards & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accCards |= 1;
        } else {
          this.user.accCards &= ~1;
        }
      },
    },
    accCardsWrite: {
      get() {
        return (this.user.accCards & 2) === 2;
      },
      set(x) {
        if (x) {
          this.user.accCards |= 3;
        } else {
          this.user.accCards &= ~2;
        }
      },
    },
    accCardsUpdate: {
      get() {
        return (this.user.accCards & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accCards |= 5;
        } else {
          this.user.accCards &= ~4;
        }
      },
    },
    accCardsDelete: {
      get() {
        return (this.user.accCards & 8) === 8;
      },
      set(x) {
        if (x) {
          this.user.accCards |= 9;
        } else {
          this.user.accCards &= ~8;
        }
      },
    },
    accCardsImport: {
      get() {
        return (this.user.accCards & 16) === 16;
      },
      set(x) {
        if (x) {
          this.user.accCards |= 17;
        } else {
          this.user.accCards &= ~16;
        }
      },
    },
    accCardsExport: {
      get() {
        return (this.user.accCards & 32) === 32;
      },
      set(x) {
        if (x) {
          this.user.accCards |= 33;
        } else {
          this.user.accCards &= ~32;
        }
      },
    },
    accCarsRead: {
      get() {
        return (this.user.accCars & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accCars |= 1;
        } else {
          this.user.accCars &= ~1;
        }
      },
    },
    accCarsWrite: {
      get() {
        return (this.user.accCars & 2) === 2;
      },
      set(x) {
        if (x) {
          this.user.accCars |= 3;
        } else {
          this.user.accCars &= ~2;
        }
      },
    },
    accCarsUpdate: {
      get() {
        return (this.user.accCars & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accCars |= 5;
        } else {
          this.user.accCars &= ~4;
        }
      },
    },
    accCarsDelete: {
      get() {
        return (this.user.accCars & 8) === 8;
      },
      set(x) {
        if (x) {
          this.user.accCars |= 9;
        } else {
          this.user.accCars &= ~8;
        }
      },
    },
    accVisitorsRead: {
      get() {
        return (this.user.accVisitors & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accVisitors |= 1;
        } else {
          this.user.accVisitors &= ~1;
        }
      },
    },
    accVisitorsWrite: {
      get() {
        return (this.user.accVisitors & 2) === 2;
      },
      set(x) {
        if (x) {
          this.user.accVisitors |= 3;
        } else {
          this.user.accVisitors &= ~2;
        }
      },
    },
    accVisitorsUpdate: {
      get() {
        return (this.user.accVisitors & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accVisitors |= 5;
        } else {
          this.user.accVisitors &= ~4;
        }
      },
    },
    accVisitorsDelete: {
      get() {
        return (this.user.accVisitors & 8) === 8;
      },
      set(x) {
        if (x) {
          this.user.accVisitors |= 9;
        } else {
          this.user.accVisitors &= ~8;
        }
      },
    },
    accVisitorsImport: {
      get() {
        return (this.user.accVisitors & 16) === 16;
      },
      set(x) {
        if (x) {
          this.user.accVisitors |= 17;
        } else {
          this.user.accVisitors &= ~16;
        }
      },
    },
    accVisitorsExport: {
      get() {
        return (this.user.accVisitors & 32) === 32;
      },
      set(x) {
        if (x) {
          this.user.accVisitors |= 33;
        } else {
          this.user.accVisitors &= ~32;
        }
      },
    },
    accCompaniesRead: {
      get() {
        return (this.user.accCompanies & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accCompanies |= 1;
        } else {
          this.user.accCompanies &= ~1;
        }
      },
    },
    accCompaniesWrite: {
      get() {
        return (this.user.accCompanies & 2) === 2;
      },
      set(x) {
        if (x) {
          this.user.accCompanies |= 3;
        } else {
          this.user.accCompanies &= ~2;
        }
      },
    },
    accCompaniesUpdate: {
      get() {
        return (this.user.accCompanies & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accCompanies |= 5;
        } else {
          this.user.accCompanies &= ~4;
        }
      },
    },
    accCompaniesDelete: {
      get() {
        return (this.user.accCompanies & 8) === 8;
      },
      set(x) {
        if (x) {
          this.user.accCompanies |= 9;
        } else {
          this.user.accCompanies &= ~8;
        }
      },
    },
    accDocumentTypesRead: {
      get() {
        return (this.user.accDocumentTypes & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accDocumentTypes |= 1;
        } else {
          this.user.accDocumentTypes &= ~1;
        }
      },
    },
    accDocumentTypesWrite: {
      get() {
        return (this.user.accDocumentTypes & 2) === 2;
      },
      set(x) {
        if (x) {
          this.user.accDocumentTypes |= 3;
        } else {
          this.user.accDocumentTypes &= ~2;
        }
      },
    },
    accDocumentTypesUpdate: {
      get() {
        return (this.user.accDocumentTypes & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accDocumentTypes |= 5;
        } else {
          this.user.accDocumentTypes &= ~4;
        }
      },
    },
    accDocumentTypesDelete: {
      get() {
        return (this.user.accDocumentTypes & 8) === 8;
      },
      set(x) {
        if (x) {
          this.user.accDocumentTypes |= 9;
        } else {
          this.user.accDocumentTypes &= ~8;
        }
      },
    },
    accWorkplacesRead: {
      get() {
        return (this.user.accWorkplaces & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accWorkplaces |= 1;
        } else {
          this.user.accWorkplaces &= ~1;
        }
      },
    },
    accWorkplacesWrite: {
      get() {
        return (this.user.accWorkplaces & 2) === 2;
      },
      set(x) {
        if (x) {
          this.user.accWorkplaces |= 3;
        } else {
          this.user.accWorkplaces &= ~2;
        }
      },
    },
    accWorkplacesUpdate: {
      get() {
        return (this.user.accWorkplaces & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accWorkplaces |= 5;
        } else {
          this.user.accWorkplaces &= ~4;
        }
      },
    },
    accWorkplacesDelete: {
      get() {
        return (this.user.accWorkplaces & 8) === 8;
      },
      set(x) {
        if (x) {
          this.user.accWorkplaces |= 9;
        } else {
          this.user.accWorkplaces &= ~8;
        }
      },
    },
    accAreasRead: {
      get() {
        return (this.user.accAreas & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accAreas |= 1;
        } else {
          this.user.accAreas &= ~1;
        }
      },
    },
    accAreasWrite: {
      get() {
        return (this.user.accAreas & 2) === 2;
      },
      set(x) {
        if (x) {
          this.user.accAreas |= 3;
        } else {
          this.user.accAreas &= ~2;
        }
      },
    },
    accAreasUpdate: {
      get() {
        return (this.user.accAreas & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accAreas |= 5;
        } else {
          this.user.accAreas &= ~4;
        }
      },
    },
    accAreasDelete: {
      get() {
        return (this.user.accAreas & 8) === 8;
      },
      set(x) {
        if (x) {
          this.user.accAreas |= 9;
        } else {
          this.user.accAreas &= ~8;
        }
      },
    },
    accItemsRead: {
      get() {
        return (this.user.accItems & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accItems |= 1;
        } else {
          this.user.accItems &= ~1;
        }
      },
    },
    accItemsWrite: {
      get() {
        return (this.user.accItems & 2) === 2;
      },
      set(x) {
        if (x) {
          this.user.accItems |= 3;
        } else {
          this.user.accItems &= ~2;
        }
      },
    },
    accItemsUpdate: {
      get() {
        return (this.user.accItems & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accItems |= 5;
        } else {
          this.user.accItems &= ~4;
        }
      },
    },
    accItemsDelete: {
      get() {
        return (this.user.accItems & 8) === 8;
      },
      set(x) {
        if (x) {
          this.user.accItems |= 9;
        } else {
          this.user.accItems &= ~8;
        }
      },
    },
    accMobileDevicesRead: {
      get() {
        return (this.user.accMobileDevices & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accMobileDevices |= 1;
        } else {
          this.user.accMobileDevices &= ~1;
        }
      },
    },
    accMobileDevicesWrite: {
      get() {
        return (this.user.accMobileDevices & 2) === 2;
      },
      set(x) {
        if (x) {
          this.user.accMobileDevices |= 3;
        } else {
          this.user.accMobileDevices &= ~2;
        }
      },
    },
    accMobileDevicesUpdate: {
      get() {
        return (this.user.accMobileDevices & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accMobileDevices |= 5;
        } else {
          this.user.accMobileDevices &= ~4;
        }
      },
    },
    accMobileDevicesDelete: {
      get() {
        return (this.user.accMobileDevices & 8) === 8;
      },
      set(x) {
        if (x) {
          this.user.accMobileDevices |= 9;
        } else {
          this.user.accMobileDevices &= ~8;
        }
      },
    },
    accSignTermRead: {
      get() {
        return (this.user.accSignTerm & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accSignTerm |= 1;
        } else {
          this.user.accSignTerm &= ~1;
        }
      },
    },
    accSignTermWrite: {
      get() {
        return (this.user.accSignTerm & 2) === 2;
      },
      set(x) {
        if (x) {
          this.user.accSignTerm |= 3;
        } else {
          this.user.accSignTerm &= ~2;
        }
      },
    },
    accSignTermUpdate: {
      get() {
        return (this.user.accSignTerm & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accSignTerm |= 5;
        } else {
          this.user.accSignTerm &= ~4;
        }
      },
    },
    accSignTermDelete: {
      get() {
        return (this.user.accSignTerm & 8) === 8;
      },
      set(x) {
        if (x) {
          this.user.accSignTerm |= 9;
        } else {
          this.user.accSignTerm &= ~8;
        }
      },
    },
    accUsersRead: {
      get() {
        return (this.user.accUsers & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accUsers |= 1;
        } else {
          this.user.accUsers &= ~1;
        }
      },
    },
    accUsersWrite: {
      get() {
        return (this.user.accUsers & 2) === 2;
      },
      set(x) {
        if (x) {
          this.user.accUsers |= 3;
        } else {
          this.user.accUsers &= ~2;
        }
      },
    },
    accUsersUpdate: {
      get() {
        return (this.user.accUsers & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accUsers |= 5;
        } else {
          this.user.accUsers &= ~4;
        }
      },
    },
    accUsersDelete: {
      get() {
        return (this.user.accUsers & 8) === 8;
      },
      set(x) {
        if (x) {
          this.user.accUsers |= 9;
        } else {
          this.user.accUsers &= ~8;
        }
      },
    },
    accSettingsRead: {
      get() {
        return (this.user.accSettings & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accSettings |= 1;
        } else {
          this.user.accSettings &= ~1;
        }
      },
    },
    accSettingsUpdate: {
      get() {
        return (this.user.accSettings & 4) === 4;
      },
      set(x) {
        if (x) {
          this.user.accSettings |= 5;
        } else {
          this.user.accSettings &= ~4;
        }
      },
    },
    accArchiveRead: {
      get() {
        return (this.user.accArchive & 1) === 1;
      },
      set(x) {
        if (x) {
          this.user.accArchive |= 1;
        } else {
          this.user.accArchive &= ~1;
        }
      },
    },
    accArchiveImport: {
      get() {
        return (this.user.accArchive & 16) === 16;
      },
      set(x) {
        if (x) {
          this.user.accArchive |= 17;
        } else {
          this.user.accArchive &= ~16;
        }
      },
    },
    accArchiveExport: {
      get() {
        return (this.user.accArchive & 32) === 32;
      },
      set(x) {
        if (x) {
          this.user.accArchive |= 33;
        } else {
          this.user.accArchive &= ~32;
        }
      },
    },
  },
  methods: {
    dataLoad() {
      axios
        .get(`/api/v1/user`)
        .then((response) => {
          this.tableData = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataNew(token: boolean) {
      const defaults: any = this.$options;
      this.user = { ...defaults.data().user };
      this.modalEdit = true;
      this.$nextTick(function () {
        const form: any = this.$refs.userForm;
        form.validate();
      });
      this.user.tokenExpire = '1970-01-01T00:00:00.000Z';
      if (token) {
        this.getTokenAndUser();
        var date = new Date();
        date.setDate(new Date().getDate() + 2 * 365);
        this.user.tokenExpire = date.toISOString();
      }
      axios
        .get('/api/v1/settings')
        .then((response) => {
          this.user.formatDate = response.data.formatDate;
          this.user.formatTime = response.data.formatTime;
          this.user.firstDay = response.data.firstDay;
          this.user.language = response.data.language;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    dataSave() {
      const form: any = this.$refs.userForm;
      if (form.validate() !== true) {
        this.$store.commit('globalMessage', this.$i18n.t('msg.formNotValid'));
      } else {
        this.user.tokenExpire = this.$moment(this.user.tokenExpire).format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z';
        if (this.user.id === 0) {
          axios
            .post('/api/v1/user', this.user)
            .then((response) => {
              if (response.data.status === 'recordExists') {
                this.$store.commit('globalMessage', this.$i18n.t('msg.loginExists'));
              } else {
                this.dataLoad();
                this.modalEdit = false;
                this.$store.dispatch('getUserSettings');
              }
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
          this.user.token = '';
        } else {
          axios
            .put('/api/v1/user', this.user)
            .then((response) => {
              if (response.data.status === 'recordExists') {
                this.$store.commit('globalMessage', 'Zadané přihlašovací jméno se již používá (Uživatel nebo Zaměstnanec)');
              } else {
                this.dataLoad();
                this.modalEdit = false;
                this.$store.dispatch('getUserSettings');
              }
            })
            .catch((err) => {
              this.$store.dispatch('catchErrHandler', err);
            });
        }
      }
    },
    dataDelete() {
      axios
        .delete(`/api/v1/user/${this.user.id}`)
        .then(() => {
          this.dataLoad();
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      this.modalEdit = false;
      this.modalDelete = false;
    },
    listAreasLoad() {
      axios
        .get('/api/v1/area')
        .then((response) => {
          this.listAreas = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    listLanguagesLoad() {
      axios
        .get('/api/v1/languages')
        .then((response) => {
          this.listLanguages = response.data;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    getTokenAndUser() {
      axios
        .get(`/api/v1/genrand/64`)
        .then((response) => {
          this.user.token = response.data.rand;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
      axios
        .get(`/api/v1/genrand/16`)
        .then((response) => {
          this.user.name = 'API-' + response.data.rand;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });
    },
    momentParse(inputDate: string) {
      return this.$moment(inputDate, this.$store.state.auth.df.date, true).isValid()
        ? this.$moment(inputDate, this.$store.state.auth.df.date).format('YYYY-MM-DD')
        : '';
    },
    async generateToken() {
      await axios
        .get(`/api/v1/genrand/64`)
        .then((response) => {
          this.user.token = response.data.rand;
        })
        .catch((err) => {
          this.$store.dispatch('catchErrHandler', err);
        });

      axios.patch(`/api/v1/user/token`, this.user).catch((err) => {
        this.$store.dispatch('catchErrHandler', err);
      });
    },
    copyToClipboard(textToCopy: string) {
      navigator.clipboard.writeText(textToCopy).then(
        () => {
          this.$store.commit('globalMessage', this.$i18n.t('msg.savedToClipboard'));
        },
        (err) => {
          this.$store.dispatch('catchErrHandler', err);
        },
      );
    },
    fillPresets(val: string) {
      switch (val) {
        case 'empty':
          this.user.accEmployees = 0;
          this.user.accEmployeeGroups = 0;
          this.user.accMessages = 0;
          this.user.accTemplates = 0;
          this.user.accCards = 0;
          this.user.accCars = 0;
          this.user.accWorkplaces = 0;
          this.user.accAreas = 0;
          this.user.accVisitors = 0;
          this.user.accCompanies = 0;
          this.user.accUsers = 0;
          this.user.accSettings = 0;
          this.user.accDocumentTypes = 0;
          this.user.accItems = 0;
          this.user.accMobileDevices = 0;
          this.user.accArchive = 0;
          break;
        case 'porter':
          this.user.accEmployees = 1;
          this.user.accEmployeeGroups = 1;
          this.user.accMessages = 0;
          this.user.accTemplates = 0;
          this.user.accCards = 1;
          this.user.accCars = 3;
          this.user.accWorkplaces = 0;
          this.user.accAreas = 1;
          this.user.accVisitors = 3;
          this.user.accCompanies = 3;
          this.user.accUsers = 0;
          this.user.accSettings = 0;
          this.user.accDocumentTypes = 1;
          this.user.accItems = 1;
          this.user.accMobileDevices = 0;
          this.user.accArchive = 0;
          break;
        case 'user':
          this.user.accEmployees = 0;
          this.user.accEmployeeGroups = 0;
          this.user.accMessages = 0;
          this.user.accTemplates = 0;
          this.user.accCards = 0;
          this.user.accCars = 0;
          this.user.accWorkplaces = 0;
          this.user.accAreas = 0;
          this.user.accVisitors = 0;
          this.user.accCompanies = 0;
          this.user.accUsers = 0;
          this.user.accSettings = 0;
          this.user.accDocumentTypes = 0;
          this.user.accItems = 0;
          this.user.accMobileDevices = 0;
          this.user.accArchive = 33;
          break;
        case 'admin':
          this.user.accEmployees = 16447;
          this.user.accEmployeeGroups = 15;
          this.user.accMessages = 15;
          this.user.accTemplates = 15;
          this.user.accCards = 63;
          this.user.accCars = 15;
          this.user.accWorkplaces = 15;
          this.user.accAreas = 15;
          this.user.accVisitors = 63;
          this.user.accCompanies = 15;
          this.user.accUsers = 15;
          this.user.accSettings = 5;
          this.user.accDocumentTypes = 15;
          this.user.accItems = 15;
          this.user.accMobileDevices = 15;
          this.user.accArchive = 49;
          break;
      }
    },
  },
});
</script>
